import { motion } from 'framer-motion';
import SectionHead from '@/components/SectionHead';
import { AGE_GROUPS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function AgeGroups() {
  return (
    <section id="age-groups" className="relative py-24 sm:py-32 bg-night" data-testid="age-groups-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="03"
          eyebrow="Age Groups"
          title={'EVERY AGE.\nEVERY STAGE.'}
          description="From first touches at five to elite refinement at sixteen — each age group follows a development focus built for that stage of the journey."
          testId="age-groups-heading"
        />
        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"
        >
          {AGE_GROUPS.map((g, i) => (
            <motion.div
              key={g.group} variants={fadeUp} custom={i}
              whileHover={{ y: -6 }}
              className={`relative overflow-hidden rounded-sm p-6 sm:p-8 border transition-[border-color,transform] duration-300 group ${
                i === 5 ? 'border-brand-gold/50 bg-brand-gold/5' : 'border-white/10 bg-night-surface hover:border-brand-red/50'
              }`}
              data-testid={`age-group-${g.group.toLowerCase()}`}
            >
              <span className="absolute -bottom-6 -right-2 font-display text-8xl sm:text-9xl leading-none text-stroke-white opacity-20 group-hover:opacity-40 transition-opacity duration-300 select-none" aria-hidden="true">
                {g.group}
              </span>
              <div className="relative">
                <div className="font-display text-4xl sm:text-5xl text-white tracking-wide">{g.group}</div>
                <div className="mt-1 text-xs sm:text-sm uppercase tracking-[0.25em] text-brand-gold font-semibold">{g.ages}</div>
                <p className="mt-4 text-sm text-gray-400 leading-relaxed max-w-[26ch]">{g.focus}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
